import { render, staticRenderFns } from "./VideoPlayerLive.vue?vue&type=template&id=44e9af64&"
import script from "./VideoPlayerLive.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerLive.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerLive.vue?vue&type=style&index=0&id=44e9af64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports